<!--
 * @Author: your name
 * @Date: 2020-10-23 14:38:18
 * @LastEditTime: 2024-07-31 15:39:44
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\children\newInterCut.vue
-->
<template>
  <div class="new-inter-cut">
    <enfold>
      <enfold-uc>
        <template slot="up">
          <img class="icon" src="@/assets/images/public/public_return.png" @click="$router.go(-1)" alt />
          <div style="font-size: 20px;">{{TITLE}}</div>
          <div class="cu-btn" @click="handleSave">{{$t('cscn1')}}</div>
        </template>
        <template slot="center">
          <div class="nic-center">
            <div class="nic-u">
              <div class="nic-u-center">
                <span>{{$t('cscn2')}}</span>
                <el-input v-model="eventName" :placeholder="$t('cscn3')"></el-input>
                <span class="nuc-error" v-show="nucError">{{$t('cscn4')}}！</span>
              </div>
              <div class="nic-u-center">
                <span>{{$t('cscn5')}}</span>
                <el-select v-model="ictId" :placeholder="$t('cscn6')">
                  <el-option v-for="item in ictList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <span class="nuc-error" v-show="nicError">{{$t('cscn7')}}！</span>
              </div>
              <div></div>
            </div>
            <div class="nic-c">
              <span>{{$t('cscn8')}}</span>
              <img src="@/assets/images/public/public_add.png" @click="addInterCut" class="icon" alt />
            </div>
            <div class="nic-d">
              <el-table :data="interCutData" style="width: 100%">
                <el-table-column :label="$t('cscn9')">
                  <template slot-scope="scope">
                    <div class="thumbnail-operation">
                      <img class="thumbnail" :src="scope.row.ref_thumb_url" alt />
                      <span>{{scope.row.ref_name}}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('cscn10')" width="120">
                  <template slot-scope="scope">
                    <span>{{scope.row.ref_time | timeLength}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="playCount" :label="$t('cscn11')" width="120">
                  <template slot-scope="scope">
                    <el-input-number :controls="false" v-model="scope.row.playCount" :min="1" :max="1000"></el-input-number>
                    <!-- <span>{{scope.row.playCount}}</span> -->
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="120">
                  <template slot-scope="scope">
                    <div class="operation">
                      <img
                        class="icon"
                        src="@/assets/images/public/public_delete.png"
                        @click="handleDel (scope.$index, scope.row)"
                        alt
                      />
                      <img
                        class="icon"
                        src="@/assets/images/public/public_edit.png"
                        @click="handleEdit (scope.$index, scope.row)"
                        alt
                      />
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </template>
      </enfold-uc>
    </enfold>
    <msg-dialog
      :dialogVisible="msgDialogVisible"
      @closeDialog="msgCloseDialog"
      dWidth="800px"
      :title="this.filmEdit?$t('cscn12'):$t('cscn13')"
    >
      <div class="md-select">
        <span>{{$t('cscn14')}}</span>
        <el-select v-model="resolutionItem" :placeholder="$t('cscn14')" @change="selectChange">
          <el-option v-for="(val, key) in resolution" :key="key" :label="key" :value="key"></el-option>
        </el-select>
      </div>
      <div class="material-box" v-loading="loading">
        <ul class="material-list">
          <li v-for="(media,index) in mediaList" :key="media.id" :class="{'formatting':(index%5 !== 0)}">
            <multimedia-item
              :cardData="media"
              :cardSelect="cardSelect"
              @mediaSelect="mediaSelect"
              @selectChange="handleCurrentChange"
            ></multimedia-item>
          </li>
        </ul>
        <pagination :current="current" :limit="limit" @currentChange="currentChange"></pagination>
      </div>
    </msg-dialog>
    <del-dialog :dialogVisible="DelDialogVisible" @closeDialog="DelCloseDialog" title="删除片源">
      <div class="dd-dialog">{{$t('cscn16')}}</div>
    </del-dialog>
  </div>
</template>

<script>
import EnfoldUc from '@/components/basics/EnfoldUC'
import enfold from '@/components/basics/Enfold'
import MsgDialog from '@/components/basics/MsgDialog'
import MultimediaItem from './MultimediaItem'
import pagination from '@/components/basics/Pagination'
import DelDialog from '@/components/basics/DelDialog'
import { mPagination } from "@/components/basics/mixins";
export default {
  name: 'newInterCut',
  mixins: [mPagination],
  data() {
    return {
      msgDialogVisible: false,
      DelDialogVisible: false,
      TITLE: '',
      eventName: "",
      ictId: "",
      ictList: [],
      mediaList: [],
      handleMedia: {},
      filmEdit: false,
      editId: 0,
      nucError: false,
      nicError: false,
      refW: "",
      cardSelect: "",
      loading: false,
      currentMedia: null,
      interCutData: [],
      // resolution: ['4k', '2k', '1080P', '720P', '360P'],
      resolutionItem: "",
      resolution: { '4K': [3264, 999999999], '2K': [2560, 3263], '1080P': [1920, 2559], '720P': [0, 1919] }
    }
  },
  created() {
    this.limit = 10;
    this.getictList();
    // 当页面刷新时返回上一级路由，避免路由传参无法获取
    !this.$route.params.event && this.$router.go(-1);
    // console.log(this.$route.params.event);
    if (this.$route.params.event === "EDIT") {
      this.TITLE = '编辑插播';
      this.icItemInit(this.$route.params.icItem)
    } else {
      this.TITLE = '新建插播';
    }

  },
  methods: {
    icItemInit(args) {
      console.log(args);
      let ele = args.content[0];
      let item = {
        ref_name: ele.ic_name,
        id: ele.m_id,
        ref_wh: ele.resolution,
        ref_time: ele.duration,
        playCount: ele.playcount,
        ref_id: ele.ref_id,
        ref_url: ele.ref_url,
        ref_size: ele.ref_size,
        ref_thumb_url: ele.ref_thumb_url
      };
      this.editId = args.id;
      this.eventName = args.name;
      this.ictId = args.it_id;
      this.interCutData.push(item);
    },
    getictList() {
      this.$http.post("/admin/InterCut/itList", {}, data => {
        this.ictList = data.list;
        console.log(this.ictList);
      });
    },
    selectChange(val) {
      let arr = [];
      arr.push(this.resolution[val]);
      this.refW = encodeURIComponent(JSON.stringify(arr));
      this.getMediaList();
    },
    addInterCut() {
      this.getMediaList();
      this.msgDialogVisible = true;
    },
    handleSave() {
      if (this.eventName === "") {
        this.nucError = true;
        // this.$msg({ showClose: true, message: '请输入插播事件名称!', type: 'warning' });
        return;
      } else {
        this.nucError = false;
      }
      if (this.ictId === "") {
        this.nicError = true;
        // this.$msg({ showClose: true, message: '请输入插播事件类型!', type: 'warning' });
        return;
      } else {
        this.nicError = false;
      }
      let content = [];
      if (this.interCutData.length === 0) {
        this.$msg({ showClose: true, message: '请选择插播事件片源!', type: 'warning' });
        return;
      } else {
        this.interCutData.forEach((ele) => {
          content.push({
            name: ele.ref_name,
            m_id: ele.id,
            resolution: ele.ref_wh,
            duration: ele.ref_time,
            playcount: ele.playCount,
            ref_id: ele.ref_id,
            ref_url: ele.ref_url,
            ref_size: ele.ref_size,
            ref_thumb_url: ele.ref_thumb_url
          })
        });
      }
      let tempData = {
        i_name: this.eventName,
        it_id: this.ictId,
        group_id: this.$cookies.get("group_id"),
        content: encodeURIComponent(JSON.stringify(content))
      }
      console.log(this.TITLE);
      // 新建插播HTTP请求
      if (this.TITLE === "新建插播") {
        this.$http.post("/admin/InterCut/addInterCutEvent", tempData, data => {
          console.log(data);
          this.$msg({ showClose: true, message: this.$t('cscn18'), type: 'success' });
          this.$router.go(-1)
        });
      }
      // 编辑插播HTTP请求
      if (this.TITLE === "编辑插播") {
        tempData.id = this.editId;
        this.$http.post("/admin/InterCut/editInterCutEvent", tempData, data => {
          console.log(data);
          this.$msg({ showClose: true, message: this.$t('cscn20'), type: 'success' });
          this.$router.go(-1)
        });
      }

    },
    handleDel(index, row) {
      console.log(index, row);
      this.handleMedia = index;
      this.DelDialogVisible = true;
    },
    DelCloseDialog(isConfirm) {
      if (isConfirm) {
        this.interCutData.splice(this.handleMedia, 1);
      }
      this.DelDialogVisible = false;
    },
    handleEdit(index, row) {
      console.log(index, row);
      this.handleMedia = index;
      this.filmEdit = true;
      this.getMediaList();
      this.msgDialogVisible = true;
    },
    msgCloseDialog(confirm = false) {
      if (confirm && this.currentMedia) {
        if (!this.filmEdit) {
          this.interCutData = [];
          this.$set(this.currentMedia, 'playCount', 1);
          this.interCutData.push(this.currentMedia);
        } else {
          this.$set(this.currentMedia, 'playCount', 1);
          this.$set(this.interCutData, this.handleMedia, this.currentMedia);
          this.filmEdit = false;
        }
      }
      this.msgDialogVisible = false;
    },
    getMediaList(media = {
      group_ids: this.groupIds,
      dir_id: this.dirId,
      limit: this.limit,
      type: "1",
      page: this.page,
      refW: this.refW
    }) {
      this.loading = true;
      this.$http.post("/admin/material/list", media, data => {
        this.mediaList = data.list ? data.list : [];
        this.current = parseInt(data.count);
        this.loading = false;
      });
    },
    // 当前选中媒体回调函数
    mediaSelect(sle) {
      this.cardSelect = sle;
    },
    // 当前选中多媒体
    handleCurrentChange(val) {
      this.currentMedia = val;
      console.log(this.currentMedia);
    },
    currentChange(val) {
      this.page = val;
      this.getMediaList();
    },

  },
  filters: {
    timeLength(time) {
      time = parseInt(time / 1000);
      let s = time % 60;
      let m = parseInt(time / 60) % 60;
      let h = parseInt(time / 60 / 60);
      return `${h < 10 ? ('0' + h) : (h)}:${m < 10 ? ('0' + m) : (m)}:${s < 10 ? ('0' + s) : (s)}`;
    }
  },
  components: {
    EnfoldUc,
    enfold,
    MsgDialog,
    MultimediaItem,
    pagination,
    DelDialog
  }
}
</script>

<style lang="scss" scoped>
.new-inter-cut {
  width: 100%;
  height: 100%;
  .nic-center {
    width: 100%;
    height: 100%;
    .nic-u {
      margin: 0px 20px;
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      .nic-u-center {
        width: 50%;
        display: flex;
        align-items: center;
        span {
          min-width: 50px;
          color: #617883;
        }
        .nuc-error {
          margin-left: 20px;
          color: red;
        }
        .el-input {
          width: 200px;
        }
        /deep/ .el-input__inner {
          width: 200px;
          border-radius: 20px;
        }
      }
    }
    .nic-c {
      margin: 0px 20px;
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #617883;
    }
    .nic-d {
      height: calc(100% - 120px);
      overflow-y: scroll;
      padding: 0px 20px;
      /deep/ .el-input__inner {
        width: 40%;
      }
      // start表格标准样式
      /deep/ .cell {
        font-size: 16px;
      }
      /deep/ .el-table__header-wrapper {
        .cell {
          font-size: 18px;
          color: #2fb3ff;
        }
        th:last-child > .cell {
          text-align: center;
        }
      }
      .operation {
        display: flex;
        justify-content: space-around;
        align-items: center;
        .icon {
          margin: 0px;
        }
      }
      // end表格标准样式
      .thumbnail-operation {
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          padding-left: 6px;
        }
        .icon {
          margin: 0px;
        }
      }
    }
  }
  .thumbnail {
    width: 80px;
    height: 50px;
  }
  .icon {
    width: 30px;
    height: 30px;
  }
  .md-select {
    span {
      margin-right: 20px;
      color: #617883;
    }
    /deep/ .el-input__inner {
      border-radius: 20px;
    }
  }
  .material-box {
    height: 314px;
    .material-list {
      display: flex;
      flex-wrap: wrap;
      min-height: 254px;

      .formatting {
        margin-left: 7px;
      }
    }
  }
  .cu-btn:active {
    color: #48dce1;
  }
}
</style>